import { gql } from "@apollo/client";

export const ASSIGN_POLICY = gql`
  mutation AssignPolicy($input: PolicyAssignmentInput!) {
    assignPolicy(input: $input)
  }
`;
